import Vue from "vue";
import axios from "axios";

const http = axios.create({
  baseURL: "https://api.sigfrotagov.com.br",
});

// Interceptor para injetar o token em cada requisição
http.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Vue.use({
  install(Vue) {
    Vue.prototype.$http = http;
  },
});

export default http;
